import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import {
  DEFAULT_PREFS,
  loadStoredAppearance,
  type AppearancePrefs,
} from '@/lib/appearance';

// Hydrated synchronously from localStorage at module load so the first render
// already has the user's theme — no flash of the default. `main.tsx` also does
// a one-shot apply before React mounts.
const initialState: AppearancePrefs = loadStoredAppearance();

const appearanceSlice = createSlice({
  name: 'appearance',
  initialState,
  reducers: {
    setPreset(state, action: PayloadAction<string>) {
      state.presetId = action.payload;
    },
    setCustomColors(state, action: PayloadAction<{ bg?: string; accent?: string }>) {
      state.presetId = 'custom';
      if (action.payload.bg !== undefined) state.customBg = action.payload.bg;
      if (action.payload.accent !== undefined) state.customAccent = action.payload.accent;
    },
    // L'interruttore della v3 NON e' parte del tema: «Reset to default» riporta il tema, non spegne la v3.
    setV3(state, action: PayloadAction<boolean>) {
      if (action.payload) state.v3 = true;
      else delete state.v3;
    },
    resetAppearance(state) {
      return { ...DEFAULT_PREFS, ...(state.v3 ? { v3: true } : {}) };
    },
  },
});

export const { setPreset, setCustomColors, setV3, resetAppearance } = appearanceSlice.actions;
export default appearanceSlice.reducer;
